// extracted by mini-css-extract-plugin
export default {"about":"about_about__HPAah","image":"about_image__zJ4uu","col2":"about_col2__EXZxV","text":"about_text__wiNGS"};